import { buildUseSetRecoilState } from "../../common/miscellaneous/buildUseSetRecoilState";
import { countriesAtom } from "../miscellaneous/countriesAtom";

export const useSetCountriesState = buildUseSetRecoilState(countriesAtom);
